import React from "react";
import ReactSpeedometer from "react-d3-speedometer";

interface SpeedometerGaugeProps {
    value?: number;
    previousMonth?: number;
}

const SpeedometerGauge: React.FC<SpeedometerGaugeProps> = ({
    value = 35,
    previousMonth = 1200, // previous month water usage in Liters or Units
}) => {
    return (
        <div className="w-full relative flex flex-col items-center justify-center px-4 bg-white rounded-lg">
            <div className="w-full max-w-xs sm:max-w-sm md:max-w-md flex items-center justify-center h-48 sm:h-56 md:h-64">
                <ReactSpeedometer
                    maxValue={100}
                    value={value}
                    needleColor="#1d4ed8"
                    startColor="#10b981"
                    endColor="#ef4444"
                    segments={10}
                    ringWidth={18}
                    needleTransitionDuration={1000}
                    currentValueText=""
                    customSegmentStops={[0, 20, 40, 60, 80, 100]}
                    needleHeightRatio={0.7}
                    fluidWidth
                />
            </div>

            {/* Current Consumption Display */}
            <div className="text-center">
                <p className="text-xl font-bold text-gray-800">
                    {previousMonth} <span className="text-base text-gray-500">Ltr</span>
                </p>
                <p className="text-[12px] text-gray-400">Previous Month</p>
            </div>
        </div>
    );
};

export default SpeedometerGauge;
